<template>
  <Dialog
    v-model="dialogsettings" :width="'70%'"
    :title="'批量设置'" :footer="true" :showClose="false"
    @confirm="handleConfirm" @close="handleClose"
  >
    <template slot="dialog-content">
      <div class="index">
      <h2>配置项</h2>
      <el-radio v-model="task" :label="1">任务点</el-radio>
      <el-radio v-model="task" :label="0">非任务点</el-radio>
      <h2 style="margin-top:18px;margin-bottom:0">选择目录</h2>
      <div class="block" style="height: calc(100% - 500px);overflow:auto">
      <el-tree
        ref="tree"
        :data="data"
        show-checkbox
        node-key="id"
        :highlight-current="false"
        :expand-on-click-node="false"
        :check-on-click-node="true"
        :indent="30"
        :accordion="true"
        :props="{
        label: 'name',
        children: 'subList'
        }"
        >
        <div class="custom-tree-node" slot-scope="{ node, data }">
        <div style="display: flex">
          <span class="level-path">{{data.levelPath}}</span>
          <span style="margin-left: 5px;display: inline-block;">{{data.name}}</span>
        </div>
        </div>
      </el-tree>
      </div>
      <p style="color:red">注：选中小节内的所有教学数据都被设为该配置项</p>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { courseServer } from '@/api/api'
export default {
  props: ['data', 'dialogsettings', 'professionId'],
  data () {
    return {
      task: null
    }
  },
  methods: {
    initForm () {
      this.task = null
      this.$refs.tree.setCheckedKeys([])
    },
    handleConfirm () {
      let directoryIds = this.$refs.tree.getCheckedKeys();
      courseServer.courseDirectoryBatchSet({
        directoryIds: directoryIds.join(),
        professionId: this.professionId,
        task: this.task,
      }).then(res => {
        const {code, message} = res
        if (code === '0') {
          this.$message.success(message)
          this.$emit('update:dialogsettings', false)
          this.$emit('update')
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    handleClose () {
      this.$emit('update:dialogsettings', false)
    },
  }
}
</script>

<style lang='scss' scoped>
.index {
  text-align: left;
  h2 {
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/coursePackage/components/settings.vue